import { FormikProps } from "formik";
import { IAttachmentFile } from "..";
import { ISendEmailDataModel } from "../../../EmailWizard/models/SendEmail";
import { ExecuteModel } from "../../../Steps/ExecuteModel";
import { ITemplateDataModel } from "../../../TemplateWizard/models/Template";

export * from "./AttachmentInput";

export interface IAttachmentInputProps {
    FormikProps?: FormikProps<ExecuteModel<ITemplateDataModel | ISendEmailDataModel>>;
}

export interface IAttachmentError {
    Attachment: IAttachmentFile;
    ErrorType: AttachmentErrorType;
}

export enum AttachmentErrorType {
    Duplicate,
    Size,
}
